// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { CheckoutInfoState } from "@keller/App/Widgets/CheckoutStepper/StepperContext";

export const paymentMethodValueDisplay = (checkoutInfoState: CheckoutInfoState) => {
    const {
        isCreditCard,
        cardType,
        lastFour,
        expirationMonth,
        expirationYear,
        isSavedPayment,
        savedPaymentDescription,
        paymentMethod,
    } = checkoutInfoState;

    if (isSavedPayment) {
        // KSC-1137: show paymentMethod based on translation key
        return translate(savedPaymentDescription);
    }

    const cardTypeDisplay = (cardType || "").charAt(0).toUpperCase() + (cardType || "").slice(1).toLowerCase();

    if (isCreditCard) {
        return `${cardTypeDisplay} **** ${lastFour}  ${translate("Exp")} ${expirationMonth}/${expirationYear}`;
    }

    // KSC-1137: show paymentMethod based on translation key
    return translate(paymentMethod);
};
